import React, { Component } from "react";
import { connect } from "react-redux";

import * as clientDataCollectActions from "../../clientDataCollect/clientDataCollectActions";

class SelectInput extends Component {
  constructor(props) {
    super(props);
    this.reference = React.createRef();
  }

  handleEvent(e) {
    if (e.type === "change" && e.detail && this.props.attributes.value !== e.detail.info.value) {
      this.props.onValueChanged(
        this.props.attributes.elementId,
        e.detail.info.value
      );
    }
  }

  componentDidMount() {
    this.setupInputs()
  }

  componentWillUnmount() {
    if(this.reference.current)
      this.reference.current.removeEventListener('change', this)
   }

  setupInputs() 
    { 
      this.reference.current.name = this.props.attributes.elementId
      this.reference.current.label = this.props.attributes.label
      this.reference.current.id = this.props.attributes.elementId
      this.reference.current.disabled = this.props.attributes.isEditable === false || this.props.attributes.isNativeField === true
      this.reference.current.required = this.props.attributes.mandatory
      this.reference.current.maxlength = this.props.attributes.fieldLength
      
      if(this.props.attributes.value !== null) 
        this.reference.current.value = this.props.attributes.value 

      this.reference.current.addEventListener('change', this)
    }

  render() {
    let dropdownItems = this.props.dropdownValues.filter(
      x => x.pickListId === this.props.attributes.pickListId
    );
    let dropdownOptions = dropdownItems.map(item => (
      <option key={item.lookupValueId} value={item.lookupValueId}>
        {item.lookupLabel}
      </option>

    ));

    return (
      <mosaic-select-input ref= {this.reference} >
        <option value = "" >Not Set</option>
        {dropdownOptions}
      </mosaic-select-input>
    );
  }
}

const mapStateToProps = state => ({
  dropdownValues: state.dropdownValues.dropdownValues
});

const mapDispatchToProps = dispatch => {
  return {
    onValueChanged: (elementId, value) =>
      dispatch(clientDataCollectActions.fieldsValueChanged(elementId, value))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectInput);
